import { useAxios } from "../../utils/hooks";

const usePageTemplates = async () => {
  const { response } = await useAxios({
    url: "/templates/",
    method: "GET",
  });
  return { response };
};

export default usePageTemplates;
